import { NgModule } from '@angular/core';

import { JobAdvertisementSharedModule } from './jobadvertisement-shared.module';
import { JobAdvertisementRoutesModule } from './jobadvertisement.routes';

import { JobAdvertisementService } from './service/jobadvertisement.service';

/**
 * CoreModule for jobadvertisements.
 */
@NgModule( {
    imports: [
        JobAdvertisementSharedModule,
        JobAdvertisementRoutesModule
    ],
    declarations: [
    ],
    exports: [
        JobAdvertisementSharedModule
    ],
    providers: [
        JobAdvertisementService
    ],
} )

export class JobAdvertisementCoreModule {
}
